<template>
  <v-card outlined>
    <v-card-title class="justify-space-between align-center flex-wrap">
      <div>
        <v-skeleton-loader
          type="text"
          width="200"
          class="mb-2"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="100"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="button" class="mt-2 mt-md-0"></v-skeleton-loader>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            type="text"
            width="150"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="200"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            type="text"
            width="150"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="180"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            type="text"
            width="120"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader
            type="text"
            width="250"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader
            type="text"
            width="220"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="200"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader
            type="text"
            width="130"
            class="mb-1"></v-skeleton-loader>
          <v-skeleton-loader
            type="text"
            width="200"
            class="mb-2"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="180"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CompanySkeletonLoader',
}
</script>
